<template lang="pug">
  .component-create-parking-group
    .row
      .columns
        label Parking Group Name
          input(type="text", v-model="name")

        label Vat
          select(v-model="vat_id")
            option(:value="null") Select custom vat
            option(v-for="vat in vats", :value="vat.id") {{vat.description }} ({{vat.name}} {{vat.percentage}}%)
      .columns
        label Booking Mode
        BookingModeSelect(v-model="reservation_type")
      .columns
        label City
        SelectizeCity(v-model="city_id" )
    .row.columns
      button.button(:class="{disabled:!name || !reservation_type}", @click="createParkingGroup") Add

</template>

<script>
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../maggieHelper";
import BookingModeSelect from '../../BookingModeSelect'
import {mapState} from "vuex";
import SelectizeCity from "../lists/selectize/SelectizeCity.vue";

export default {
  name: "CreateParkingGroup",
  components: {SelectizeCity, BookingModeSelect},
  data() {
    return {
      name: null,
      reservation_type: null,
      vat_id: null,
      city_id: null,
    }
  },
  methods: {
    createParkingGroup() {
      var body = {
        name: this.name,
        reservation_type: this.reservation_type,
        vat_id: this.vat_id,
        city_id: this.city_id,
      }
      KeplerBackofficeSdk.parkingGroups.make(body, () => {

        MaggieHelper.notification('create-esit', 'Parking group created successfully')
        this.$router.push({path: 'assets', name: 'management'})

      })
    }
  },
  computed: {
    ...mapState({
      vats: state => state.configuration.vats,
    }),
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateParkingGroup.vue?7d3a3dd5